const messages = {
  title: "Marketingové súhlasy",
  required: "Povinné",
  answered: "✓ Zodpovedané",
  read: "Prečítané",
  notRead: "Neprečítané",
  alreadyAnswered: "Už zodpovedané",
  requiredQuestionsMustBeAccepted:
    "Je potrebné prijať ešte {count} povinných otázok",
  pleaseAnswerQuestions: "Odpovedzte prosím na nasledujúce otázky:",
  iAccept: "Súhlasím",
  scrollToUnlock: "Pre odomknutie posuňte na koniec",
  fieldRequired: "Toto pole je povinné",
  scrollToContinue: "↓ Pre pokračovanie posuňte na koniec",
  saving: "Ukladá sa...",
  saveConsents: "Uložiť súhlasy",
  allRequiredAccepted: "✓ Všetky povinné otázky prijaté",
  requiredConsentsCompleted:
    "{completed}/{total} povinných súhlasov vyplnených",
  selectConsentToView:
    "Vyberte súhlas zo zoznamu na zobrazenie obsahu",
  readAllContentFirst: "Najprv si prečítajte celý obsah: {names}",
  acceptAllRequiredIn:
    "Prijmite všetky povinné otázky v: {names}",
  acceptAllBeforeSaving:
    "Pred uložením prijmite všetky povinné otázky.",
  failedToSave: "Súhlasy sa nepodarilo uložiť. Skúste to znova.",
  errorSaving:
    "Pri ukladaní súhlasov došlo k chybe. Skúste to znova.",
  failedToLoad: "Súhlasy sa nepodarilo načítať. Obnovte stránku.",
  viewPdf: "Zobraziť PDF",
  requiredConsentTitle: "Povinný súhlas",
  acceptAndContinue: "Prijať a pokračovať",
};

export default {
  messages,
};
